// apps/admin/src/hooks/use-alignment-guides.ts
//
// P5 UI Polish W2 T3 — alignment guides pure helper (spec §3.2).
//
// Given a "moving" zone + the static "others", emit vertical/horizontal
// guide lines when any of the moving zone's edges or center align
// within SNAP_THRESHOLD pixels of any other zone's edges or center.

const SNAP_THRESHOLD = 4;

export interface ZoneRect {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export type Guide =
  | { kind: 'vertical'; x: number }
  | { kind: 'horizontal'; y: number };

export function computeGuides(moving: ZoneRect, others: ReadonlyArray<ZoneRect>): Guide[] {
  const m = {
    left: moving.x,
    right: moving.x + moving.width,
    centerX: moving.x + moving.width / 2,
    top: moving.y,
    bottom: moving.y + moving.height,
    centerY: moving.y + moving.height / 2,
  };
  const vSet = new Set<number>();
  const hSet = new Set<number>();
  for (const o of others) {
    const e = {
      left: o.x,
      right: o.x + o.width,
      centerX: o.x + o.width / 2,
      top: o.y,
      bottom: o.y + o.height,
      centerY: o.y + o.height / 2,
    };
    for (const my of [m.left, m.right, m.centerX]) {
      for (const ox of [e.left, e.right, e.centerX]) {
        if (Math.abs(my - ox) <= SNAP_THRESHOLD) vSet.add(ox);
      }
    }
    for (const my of [m.top, m.bottom, m.centerY]) {
      for (const oy of [e.top, e.bottom, e.centerY]) {
        if (Math.abs(my - oy) <= SNAP_THRESHOLD) hSet.add(oy);
      }
    }
  }
  return [
    ...Array.from(vSet).map((x): Guide => ({ kind: 'vertical', x })),
    ...Array.from(hSet).map((y): Guide => ({ kind: 'horizontal', y })),
  ];
}
